import styled, { css } from "styled-components";

const SimpleButton = styled("button")<{
  bg?: string;
  disabled?: boolean;
  secondary?: boolean;
}>`
  padding: 1rem 1.5rem;
  background: ${(props) =>
    props.bg === null || props.bg === undefined
      ? props.disabled
        ? "rgba(116, 113, 113, 0.6)"
        : props.secondary
        ? "transparent"
        : "#fff"
      : props.bg};
  border-radius: 6px;
  color: ${(props) =>
    props.secondary ? "#fff" : props.disabled ? "#AAAAAA" : "#000D30"};
  border-style: none;
  border: ${(props) =>
    props.secondary
      ? "1px solid #fff"
      : props.disabled
      ? "2px solid #747171"
      : "none"};
  &:active {
    ${(props) =>
      !props.disabled &&
      css`
        transform: scale(0.98);
        box-shadow: 3px 2px 22px 1px rgba(0, 0, 0, 0.24);
      `}
  }
  &:hover {
    ${(props) =>
      !props.disabled &&
      css`
        cursor: pointer;
        box-shadow: 0px 0px 20px rgba(255, 255, 255, 0.4);
      `}
  }
  font-size: 16px;
  @media screen and (max-width: 1400px) {
    font-size: 14px;
    padding: 0.8rem 1.2rem;
  }
`;

export default SimpleButton;
